import React from "react";

const DetailDescription = ({ course_desc, course_info }) => {
  return (
    <div
      className="tab-pane fade show active"
      id="course-description"
      role="tabpane1"
      aria-labelledby="course-description-tab"
    >
      <div className="course-description">
        <h4 className="mb-4">Opis kursa</h4>
        <p>{course_desc}</p>
        
      </div>
    </div>
  );
};

export default DetailDescription;
